import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
const menuWidth = 400;

export const assignEventMenuStyles = makeStyles((theme: Theme) =>
    createStyles({
        menu: {
            width: menuWidth,
            height: "100%",
            borderRadius: "0px",
            padding: "20px 20px 20px 30px ",
        },
        closeIcon: { float: "right", cursor: "pointer" },
        innerMenu: {
            padding: "10px",
        },
        textContainer: {
            marginTop: "30px ",
        },
        subText: {
            lineHeight: "120%",
            marginTop: "10px",
        },

        searchContainer: {
            marginTop: "40px",
            marginBottom: "30px",
        },
        searchInput: {
            "& .MuiOutlinedInput-input": {
                padding: "16.5px 12px",
            },
            width: "100%",
            borderRadius: "4px",
            marginTop: "15px",
        },
        searchIcon: {
            borderRadius: "4px",
            backgroundColor: "#270ADC",
            color: "white",
            padding: "12px",
            minWidth: "40px",
            "&:hover": {
                backgroundColor: "#270ADC",
            },
        },
        formControl: {
            width: 330,
            maxHeight: 100,
            backgroundColor: "white",

            "& .MuiSelect-select:focus": {
                backgroundColor: "inherit",
            },
            "& .MuiInputBase-root": {
                border: `1px solid ${theme.colors.neutrals.neutral200}`,
                padding: 0,
            },
            "& .MuiSelect-root": {
                padding: "10px",
            },
            "& .MuiSelect-icon": {
                width: "12px",
                height: "12px",
                marginTop: "6px",
                marginRight: "10px",
            },
            "& .MuiPopover-paper": {
                maxHeight: "100px",
            },
        },

        menuItem: {
            "&:hover": {
                backgroundColor: `${theme.colors.primary.blue75}`,
            },
        },
        selected: {
            "&.Mui-selected": {
                backgroundColor: `${theme.colors.primary.blue500}`,
                color: "white",
            },
            "&.Mui-selected:hover": {
                backgroundColor: `${theme.colors.primary.blue500}`,
            },
        },
        container: {
            textAlign: "center",
        },
    })
);
